var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_5785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3327 2.33301H6.99935C5.71018 2.33301 4.67768 3.37717 4.67768 4.66634L4.66602 23.333C4.66602 24.6222 5.69852 25.6663 6.98768 25.6663H20.9993C22.2885 25.6663 23.3327 24.6222 23.3327 23.333V9.33301L16.3327 2.33301ZM18.666 20.9997H9.33268V18.6663H18.666V20.9997ZM18.666 16.333H9.33268V13.9997H18.666V16.333ZM15.166 10.4997V4.08301L21.5827 10.4997H15.166Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_5785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillsIcon);
export default __webpack_public_path__ + "static/media/BillsIcon.e8c56fdf00ec6db593c98d2408ea2eec.svg";
export { ForwardRef as ReactComponent };